var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data)?_c('div',{staticClass:"page",domProps:{"innerHTML":_vm._s(_vm.data)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }